export default "__VITE_ASSET__DAt7EmUN__"